// @flow
import * as React from 'react';

export default function JsonScript({
  id,
  type = 'application/json',
  value,
}: {|
  id?: string,
  type?: 'application/json' | 'application/ld+json',
  value: any,
|}) {
  const json = JSON.stringify(value).replace(/<\//g, '<\\/');
  // eslint-disable-next-line react/no-danger
  return <script id={id} type={type} dangerouslySetInnerHTML={{ __html: json }} />;
}
